import { Component } from '@angular/core';

@Component({
  selector: 'gtapp-view-sop',
  standalone: false,
  templateUrl: './view-sop.component.html',
  styleUrl: './view-sop.component.scss',
})
export class ViewSopComponent {}
